import React from 'react'
import UnblockUserlist from '../../components/unblockusercomponents/UnblockUserlist'

function Userblocklistpage({renderPageContent}) {
    return (
        <>
             <UnblockUserlist renderPageContent={renderPageContent}/>
        </>
    )
}

export default Userblocklistpage
